__turbopack_context__.v({
  "lds-ripple": "nS2Y5q_lds-ripple",
  "ldsripple": "nS2Y5q_ldsripple",
});
